import { IS_MOBILE_BROWSER } from 'reactApp/appHelpers/configHelpers';

const prefix = IS_MOBILE_BROWSER ? 'touch' : 'up';
const postfix = IS_MOBILE_BROWSER ? 'touch' : 'upline';

export const getAdvDisableLink = ({ isAnonymous }) => {
    return isAnonymous
        ? `/promo/?utm_source=cloud-ads-${prefix}&utm_medium=referral&utm_campaign=ads-${postfix}#year`
        : `/subscriptions/?utm_source=cloud-subs-ads-up-buy&utm_medium=referral&utm_campaign=subs-ads-${postfix}#year`;
};
